import { useAssociateRequestContext } from '../../contexts/AssociateRequestProvider';
import { Associate } from '../../types/associates';
import { showFullName } from '../../utils/commonFunctions';

const AssociateRequestDetails = ({ associate }: { associate: Associate }) => {
  // integration of context hooks here
  const { setShowDetailsModal, setAssociate } = useAssociateRequestContext();

  // rendering associate request details component here
  return (
    <div>
      <button
        onClick={() => {
          setShowDetailsModal(true);
          setAssociate(associate);
        }}
        className='hover:opacity-70 active:scale-95 duration-300'
      >
        <p className='font-medium text-base-light-blue'>{`${showFullName(
          associate.first_name,
          associate.middle_name,
          associate.last_name
        )} `}</p>
      </button>
    </div>
  );
};

export default AssociateRequestDetails;
